<template>
  <el-dialog :visible="visible"
             @open.once="insertTooltips"
             @close="close"
             width="975px">
    <h2>Instrukcje do formularza</h2>
    <p class="h2-subtitle" v-required-mark>Wymagane pola są oznaczone</p>

    <div class="mw-400" ref="wrapper">
      <topup-form :params="tutorialData"/>
    </div>

    <button type="button" @click="close" class="btn">Zamknij</button>
  </el-dialog>
</template>

<script>
import TopupForm from '@/pge/components/Topup/Form'
import tippy from 'tippy.js'

const tippieContents = [
  'Wpisz numer kodu kreskowego. Kod kreskowy znajdziesz na swojej karcie klienta.',
  'Wpisz deklarowaną kwotę zakupu. Kwota deklarowana jest podstawą do obliczenia kwoty do zapłaty.',
  'Wpisz adres e-mail, na który chcesz otrzymać wiadomość z kodem doładowania.',
  'Podaj numer telefonu komórkowego, na który chcesz uzyskać sms z kodem doładowania.'
]

export default {
  name: 'TopupGuideTutorial',
  components: {
    TopupForm
  },
  props: ['visible'],
  data: () => {
    return {
      tutorialData: {
        amountZl: '150',
        amountGr: '00'
      }
    }
  },
  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    insertTooltips () {
      setTimeout(this.setTippy, 100)
    },
    setTippy () {
      tippieContents.forEach((content, index) => {
        const elForTippy = this.$refs.wrapper.querySelector('.form-group:nth-child(' + (index + 1) + ')')
        tippy(
          elForTippy,
          {
            appendTo: window.outerWidth >= 768 ? this.$refs.wrapper : elForTippy,
            trigger: 'manual',
            content: content,
            placement: window.outerWidth >= 768 ? 'right' : 'bottom',
            hideOnClick: false,
            showOnCreate: true,
            offset: [0, 30]
          }
        )
      })
    }
  }
}
</script>
